/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { languageIdGet } from '../fn/language/language-id-get';
import { LanguageIdGet$Params } from '../fn/language/language-id-get';
import { LanguageModel } from '../models/language-model';
import { LanguageModelSearchResultModel } from '../models/language-model-search-result-model';
import { languagePost } from '../fn/language/language-post';
import { LanguagePost$Params } from '../fn/language/language-post';
import { languageSearchLanguagePost } from '../fn/language/language-search-language-post';
import { LanguageSearchLanguagePost$Params } from '../fn/language/language-search-language-post';

@Injectable({ providedIn: 'root' })
export class MDILanguageService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `languageSearchLanguagePost()` */
  static readonly LanguageSearchLanguagePostPath = '/Language/SearchLanguage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `languageSearchLanguagePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  languageSearchLanguagePost$Response(params?: LanguageSearchLanguagePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LanguageModelSearchResultModel>> {
    return languageSearchLanguagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `languageSearchLanguagePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  languageSearchLanguagePost(params?: LanguageSearchLanguagePost$Params, context?: HttpContext): Observable<LanguageModelSearchResultModel> {
    return this.languageSearchLanguagePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<LanguageModelSearchResultModel>): LanguageModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `languageIdGet()` */
  static readonly LanguageIdGetPath = '/Language/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `languageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageIdGet$Response(params: LanguageIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LanguageModel>> {
    return languageIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `languageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageIdGet(params: LanguageIdGet$Params, context?: HttpContext): Observable<LanguageModel> {
    return this.languageIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<LanguageModel>): LanguageModel => r.body)
    );
  }

  /** Path part for operation `languagePost()` */
  static readonly LanguagePostPath = '/Language';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `languagePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  languagePost$Response(params?: LanguagePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return languagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `languagePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  languagePost(params?: LanguagePost$Params, context?: HttpContext): Observable<string> {
    return this.languagePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
